// Swappable logo: replace ShieldMark with <img src="/assets/brand/logo.svg" /> when final assets ship.
export const ShieldMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 72" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="sms-silver" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#E4E7EA" />
        <stop offset="100%" stopColor="#8A9096" />
      </linearGradient>
    </defs>
    <path
      d="M32 3 L58 12 V36 C58 52 46 63 32 69 C18 63 6 52 6 36 V12 Z"
      fill="#0A0A0A"
      stroke="url(#sms-silver)"
      strokeWidth="3.5"
    />
    <path
      d="M32 10 L51 17 V36 C51 48 42 56.5 32 61.5 Z"
      fill="#A8E600"
    />
    <path
      className="animate-trace"
      d="M32 10 L51 17 V36 C51 48 42 56.5 32 61.5 C22 56.5 13 48 13 36 V17 Z"
      fill="none"
      stroke="#A8E600"
      strokeWidth="2"
      strokeDasharray="400"
    />
  </svg>
);

export const ShieldLogo = ({ light = false, compact = false }) => (
  <span className="inline-flex items-center gap-3" data-testid="header-logo-shield">
    <ShieldMark className={compact ? "h-8 w-8" : "h-10 w-10"} />
    <span className="leading-none">
      <span
        className={`block font-display font-bold uppercase tracking-tight ${
          compact ? "text-lg" : "text-xl"
        } ${light ? "text-ink" : "text-white"}`}
      >
        Show Me <span className="text-lime">Shield</span>
      </span>
      {!compact && (
        <span className="mt-1 block font-mono text-[9px] uppercase tracking-[0.3em] text-zinc-400">
          Supplemental &bull; Life &bull; Health
        </span>
      )}
    </span>
  </span>
);
